import * as React from 'react';
import { ModuleProps } from 'src/components/common/module-util';  
import { ContentPanelComponentMap } from './content-panel-map';

// Css Style Import
import(/* webpackChunkName: "v1-content-panel-styles" */ 'src/components/common/modules/v1/content-panel/styles/content-panel.css');

/**
 * Looks at the code-split ContentPanel map and renders the desired ui component based on the name.
 */
export const ContentPanelComponent = (props: ModuleProps) => {
  const component = ContentPanelComponentMap;

  if (!component) {
    return null;
  }

  return React.createElement(component as any, props);
};
 